import { render, staticRenderFns } from "./tab4ServiceCenterAnalysis.vue?vue&type=template&id=06fd2476&scoped=true"
import script from "./tab4ServiceCenterAnalysis.vue?vue&type=script&lang=js"
export * from "./tab4ServiceCenterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./tab4ServiceCenterAnalysis.vue?vue&type=style&index=0&id=06fd2476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd2476",
  null
  
)

export default component.exports